<template>
  <qx-card title="列表">
    <SendCarDialog ref="sendCarDialog" @sub="getData"></SendCarDialog>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>发布货源
        </el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title"/>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55" :selectable="judgeSelect"/>-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
                :fixed="item.fixed"
                align="center"
                v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'id'">
                  <span class="primary cur" @click="toGoodsDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 线路名称 -->
                <section
                    v-else-if="scope.column.property === 'lineName'"
                >
                  <span
                      :class="{
                      primary: scope.row.lineId !== -1 && scope.row.lineId !==null,
                      cur: scope.row.lineId !== -1 && scope.row.lineId !==null,
                    }"
                      @click="toLineDetail(scope.row)"
                  >{{
                      scope.row[scope.column.property]
                    }}
                  </span>
                </section>
                <!-- 线路名称 end -->
                <!-- 客户名称 -->
                <section v-else-if="scope.column.property === 'customerName'">
                  <span  :class="{
                      primary: scope.row.customerId !== -1 && scope.row.customerId !==null,
                      cur: scope.row.customerId !== -1 && scope.row.customerId !==null,
                    }"
                         @click="toCustomerDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                </section>
                <!-- 客户名称 end -->
                <!-- 司机运价 -->
                <section
                    v-else-if="scope.column.property === 'orderGoodsDriverTariffs'"
                >
                  <span>
                    {{scope.row[scope.column.property]?scope.row[scope.column.property][scope.row[scope.column.property].length-1].sourceString:''}}
                  </span>
                </section>
                <!-- 司机运价 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="170"
              fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isShowDropdown="true"
                  :isCenter="true"
                  :btnList="[
                  {
                    permpisions: '',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row, 'edit'),
                  },
                   {
                    permpisions: '',
                    showCondition: scope.row.dispatchMethod===2,
                    name: '去派车',
                    event: () => showSendCarDialog(scope.row),
                  },
                   {
                    permpisions: '',
                    showCondition: scope.row.goodsStatus===1|| scope.row.goodsStatus===2,
                    name: '结束货源',
                    event: () => toFinishGoods(scope.row),
                  },
                  {
                    permpisions: '',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemoveGoods(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import SendCarDialog from '@/views/manage/operate/goods/list/sendCarDialog/sendCarDialog';
import {
  deleteOrderSourceOfGoods,
  goodsList, stopOrderSourceOfGoodsById,
} from 'api/operate';

export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn, // 操作按钮
    TableSetting, // 表格设置
    SendCarDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'id', label: '货源编号', fixed: true},
          {prop: 'lineName', label: '线路名称'},
          {prop: 'orderLine', label: '运输线路'},
          {prop: 'customerName', label: '客户名称'},
          {prop: 'goodsStatusName', label: '货源状态'},
          {prop: 'dispatchMethodName', label: '派单方式'},
          {prop: 'orderGoodsDriverTariffs', label: '司机运价'},
          {prop: 'releaseScopeName', label: '发布范围'},
          {prop: 'requiredTrainNumber', label: '需求车次'},
          {prop: 'receivedTrainNumber', label: '已接车次'},
          {prop: 'dispatchedTrainNumber', label: '已派车次'},
          {prop: 'cancelTrainNumber', label: '取消车次'},
          {prop: 'goodsName', label: '货物名称'},
          {prop: 'weight', label: '货物重量'},
          {prop: 'square', label: '货物体积'},
          {prop: 'contacts', label: '联系人'},
          {prop: 'contactsPhone', label: '联系方式'},
          {prop: 'updateBy', label: '发布人员'},
          {prop: 'updateTime', label: '发布时间'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: goodsList,
    toEdit (item) {
      this.jump({
        label: item ? `修改货源-${item.id}` : '发布货源',
        url: `/manage/operate/goods/list/edit${item ? '?id=' + item.id : ''}${item ? '&rawOrderId=' + item.rawOrderId : ''}`,
        full: true,
      });
    },
    toGoodsDetail (item) {
      this.jump({
        label: `货源详情-${item.id}`,
        url: `/manage/operate/goods/list/detail?id=${item.id}&orderId=${item.rawOrderId}`,
        full: true,
      });
    },
    toLineDetail (item, type = '') {
      if (item.lineId === -1 || item.lineId === null) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.lineId}&type=${type}`,
        full: true,
      });
    },
    toCustomerDetail (item, type = '') {
      if (item.customerId === -1 || item.customerId === null) {
        return;
      }
      this.jump({
        label: '客户详情',
        url: `/manage/archives/customer/archives/detail?id=${item.customerId}&type=${type}`,
      });
    },
    showSendCarDialog (item) { // 去派车
      this.$refs.sendCarDialog.show(item);
    },
    async toFinishGoods (item) { // 结束货源
      const confirmRes = await this.$confirm('确定停止货源发布', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await stopOrderSourceOfGoodsById({
          id: item.id,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
    async toRemoveGoods (item) { // 删除
      const confirmRes = await this.$confirm(`确定要删除【${item.id}】这个货源吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await deleteOrderSourceOfGoods({
          id: item.id,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
